module.exports = __webpack_public_path__ + "static/media/fail.57d89c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/fail.png
// module id = 803
// module chunks = 0